/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    pre: "pre",
    blockquote: "blockquote",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Getting Started"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "styled-components"
      }), " utilises tagged template literals to style your components."]
    }), "\n", _jsx(_components.p, {
      children: "It removes the mapping between components and styles. This means that when you're defining your styles, you're actually creating a normal React component, that has your styles attached to it."
    }), "\n", _jsx(_components.p, {
      children: "This example creates two simple components, a wrapper and a title, with some styles attached to it:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// Create a Title component that'll render an <h1> tag with some styles\nconst Title = styled.h1`\n  font-size: 1.5em;\n  text-align: center;\n  color: #BF4F74;\n`;\n\n// Create a Wrapper component that'll render a <section> tag with some styles\nconst Wrapper = styled.section`\n  padding: 4em;\n  background: papayawhip;\n`;\n\n// Use Title and Wrapper like any other React component – except they're styled!\nrender(\n  <Wrapper>\n    <Title>\n      Hello World!\n    </Title>\n  </Wrapper>\n);\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "This is a live editor, so play around with the code to get a feel for what it's like to work with styled-components!"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "The CSS rules are automatically vendor prefixed, styled-components takes care of that for you!"
      }), "\n", _jsxs(_components.p, {
        children: ["Styled components uses ", _jsx(_components.a, {
          href: "https://stylis.js.org/",
          children: "stylis.js"
        }), " package under the hood for prefixing the css rules."]
      }), "\n", _jsxs(_components.p, {
        children: ["For additional information about the supported prefixes in stylis.js visit their ", _jsx(_components.a, {
          href: "https://github.com/thysultan/stylis.js",
          children: "repository"
        }), "."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
